export const DEFAULT_NAMES = ['Enter', 'team', 'mates', 'names'];
export const LOOP_CONFIG = { stiffness: 180, damping: 8 };